import { useEffect } from "react";

const useGTM = (gtmId) => {
  useEffect(() => {
    if (!gtmId) return;

    // Inject <script> into <head>
    if (!document.getElementById(`gtm-script-${gtmId}`)) {
      const script = document.createElement("script");
      script.id = `gtm-script-${gtmId}`;
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');
      `;
      document.head.insertBefore(script, document.head.firstChild);
    }

    // Inject <noscript> into <body>
    if (!document.getElementById(`gtm-noscript-${gtmId}`)) {
      const noscript = document.createElement("noscript");
      
      noscript.id = `gtm-noscript-${gtmId}`;
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.insertBefore(noscript, document.body.firstChild);
    }

    return () => {
      document.getElementById(`gtm-script-${gtmId}`)?.remove();
      document.getElementById(`gtm-noscript-${gtmId}`)?.remove();
    };
  }, [gtmId]);
};

export default useGTM;
